import React, { lazy } from "react";
import { Link } from "react-router-dom";

//material UI
import { Grid, Typography } from "@mui/material";

//components
import { Image } from "../../components/Image";
import CustomButton from "../../components/Button";

//images
import QuizLostImage from "../../images/quiz-lost.svg";

//icons
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

//components
const GenderHeader = lazy(() => import("../../components/Header"));

export default function QuizLostScreen() {
  return (
    <Grid container spacing={2} sx={{ minHeight: "100vh" }}>
      <Grid item xs></Grid>
      <Grid item xs={10} zeroMinWidth>
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: {
              xs: "25%",
              sm: "5%",
              md: "5%",
              lg: "0",
              xl: "0",
            },
          }}
        >
          <Grid item xs={12}>
            <GenderHeader></GenderHeader>
          </Grid>
          <Grid
            item
            xs={12}
            textAlign={"center"}
            sx={{
              height: {
                xs: "35vh",
                sm: "50vh",
                md: "45vh",
                lg: "45vh",
                xl: "45vh",
              },
            }}
          >
            <img
              src={QuizLostImage}
              width={"95%"}
              height={"100%"}
              alt="Duas pessoas concentradas no computador com o objetivo de se prepararem melhor para o quiz."
            ></img>
          </Grid>
          <Grid item xs={12}>
            <Typography
              color={"#000000"}
              letterSpacing={0}
              fontSize={{
                xs: "2em",
                sm: "2em",
                md: "2em",
                lg: "4em",
                xl: "4em",
              }}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
              lineHeight={"2.41em"}
              textAlign={"center"}
            >
              Continue a praticar!
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <AutoStoriesIcon sx={{ padding: "0 0.3em" }} />
            <AutoStoriesIcon sx={{ padding: "0 0.3em" }} />
            <AutoStoriesIcon sx={{ padding: "0 0.3em" }} />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: {
                xs: "5%",
                sm: "5%",
                md: "5%",
                lg: "2%",
                xl: "2%",
              },
              textAlign: "center",
            }}
          >
            <Link to={"/genderonext"}>
              <CustomButton
                title={"jogue novamente"}
                backcolor={"#EDE838"}
              ></CustomButton>
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
